import { executionReportsDatabase } from '../indexedDB'
import { reportsRoutes } from '../routes'

export default () => {
    return new Promise((resolve) => {
        const detect = async () => {
            const db = await executionReportsDatabase.initDb()
            const { database } = db
            let response = []
            response = await executionReportsDatabase.consultar(database)
            if (response.length === 0) {
                resolve(true)
                return
            }
            response.forEach(async (executionReportData, index) => {
                const res = await reportsRoutes.getReportById(executionReportData.reportId)
                if (res.data) {
                    if (res.data.level !== undefined) {
                        if (res.data.level === 4) {
                            await executionReportsDatabase.eliminar(executionReportData._id, database)
                        }
                        if (index === (response.length - 1)) {
                            resolve(true)
                        }
                    }
                }
            })
        }
        detect()
    })
}
